var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-jstree',{attrs:{"data":_vm.items,"show-checkbox":true,"multiple":true},on:{"item-click":_vm.itemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }